import { createAction, props } from '@ngrx/store';
import { SettlementReportReducerInitialState } from '../reducers/admin-settlement-report.reducer';

const prefix = '[Admin-settlement-report]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<SettlementReportReducerInitialState>>()
);

export const setQueryAction = createAction(
  `${prefix} set query`,
  props<
    Partial<{
      minDate: string;
      maxDate: string;
      status: string;
      rhId: string;
    }>
  >()
);

export const resetQueryAction = createAction(
  `${prefix} reset query`,
  props<any>()
);
